module.exports = __webpack_public_path__ + "img/RetireAtHome.5f507a09.png";